// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__191EG","right":"styles_right__38Jc7"};